import { Injectable, Optional } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { AuthServiceService } from '../services/auth-service.service';
import { AzureAuthService } from '../services/azure-auth.service';
import { InfoDialogComponent } from '../components/info-dialog/info-dialog.component';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { ToastrService } from 'ngx-toastr';


@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {

  // dialog: MatDialog;
  constructor(public auth: AuthServiceService,@Optional() public dialog: MatDialog,
    public router: Router, public azureAuthService: AzureAuthService,private toaster:ToastrService) {
  
  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.auth.isAuthenticated()) {
      return true;
    }
    // else if (this.azureAuthService.isLoggedIn()) {
    //   this.getJWTToken();
    //   return true;
    // } 
    else {
        localStorage.setItem("redirectTo", state.url)
        const dialogRef = this.dialog.open(InfoDialogComponent, {
          width: '280px',
          data: { message: 'Please Login', class: 'text-danger' }
        });
        dialogRef.afterClosed().subscribe(result => {
          this.router.navigate(['/login']);
        });
      // this.router.navigate(['/login']);
      return false;
    }
  }

}
